import { type PropertyValue } from 'src/types';
import {
  GET_PROPERTY_VALUES_SUCCESS,
  GET_RETURN_PROPERTY_VALUES_SUCCESS,
} from '../actions/stationPropertyValues';

type PropertyValueMap = Record<string, PropertyValue[]>;

const INITIAL_STATE: PropertyValueMap = {};

const mergeResults = (
  previousState: PropertyValueMap,
  nextState: PropertyValueMap
): PropertyValueMap => {
  return Object.entries(nextState).reduce<PropertyValueMap>((results, [key, currentValue]) => {
    const prevValue = results[key] ?? [];
    return {
      ...results,
      [key]: currentValue && currentValue.length > 0 ? [...prevValue, ...currentValue] : prevValue,
    };
  }, previousState);
};

// Merges outgoing property values and return property values into one map
// Makes it easier to print labels no matter the source of property values
const allPropertyValuesReducer = (state = INITIAL_STATE, action): PropertyValueMap => {
  switch (action.type) {
    case GET_RETURN_PROPERTY_VALUES_SUCCESS:
      return mergeResults(state, action.data);

    case GET_PROPERTY_VALUES_SUCCESS:
      return mergeResults(state, action.data);

    default:
      return state;
  }
};

export default allPropertyValuesReducer;
